import React, { useCallback, useEffect, useState } from 'react'
import Header from '../layout/Header'
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { API_BASE } from "../../config/env";
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { getApplication } from '../../actions/application/getApplication';
import { connect } from 'react-redux';
import { deleteAttachmet, resetDeleteAttachment } from '../../actions/attachment/deleteAttachment';

function FileUpload(props) {
    const { Id } = useParams();

    const [fileType, setFileType] = useState("3");
    const [fileModel, setFileModel] = useState("");
    const [fileName, setFileName] = useState("11");
    const [counter, setCounter] = useState(0);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        window.location.reload()
    }, [])

    useEffect(() => {
        dispatch(getApplication(Id))
    }, [dispatch]);

    useEffect(() => {
        if (props.deleteAttachment.done) {
            Swal.fire({
                position: 'bottom-end',
                icon: 'success',
                title: 'Dosya başarıyla silindi',
                showConfirmButton: false,
                timer: 1000
            })
            dispatch(getApplication(Id))
            dispatch(resetDeleteAttachment());
        }
    }, [props.deleteAttachment])

    const handleButtonClick = () => {
        setCounter(counter + 1);
    };
    const getUploadParams = ({ file }) => {
        const body = new FormData();
        body.append("file", file);
        var vnaFileType = fileType == "4" ? "1" : fileType;
        body.append("fileType", vnaFileType.toString());
        body.append("fileName", fileName);
        setIsDisabled(true);
        return {
            url: `${API_BASE}/api/v2/vna/upload-file`,
            method: "POST",
            headers: {
                "Accept-Language": "tr-tr",
                "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
                "One-Id": "12345",
                "Client-Id": "123456"
            },
            body
        };
    };
    const handleUploadSuccess = useCallback((file, response) => {
        setUploadedFiles(prevFiles => [...prevFiles, file.name]);
    }, []);

    const handleUploadError = useCallback((file, error) => {
        // Hata durumunda da dosya ismini ekleyebilirsiniz
        setUploadedFiles(prevFiles => [...prevFiles, file.name]);
    }, []);

    function handleSubmit() {
        navigate("/select-doctor/" + Id);
    }

    return (
        <div>
            <Header />

            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">
                    <li className="text-sm">
                        <a
                            className="flex items-center text-gray-500 hover:text-blue-600" href="#">
                            Yeni Başvuru
                            <svg className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </a>
                    </li>
                    <li className="text-sm">
                        <a
                            className="flex items-center text-gray-500 hover:text-blue-600" href="#">
                            Talep Formu
                            <svg className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </a>
                    </li>
                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Dosya Yükleme
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <h1 className='text-2xl font-semibold text-start mt-5 ps-5 md:ml-64'>Hastalığınızla İlgili Dosyalar</h1>
            <div className='mt-5 ps-5 pe-5 md:ml-64'>
                <label for="hs-select-label" class="block text-sm font-medium mb-2 dark:text-white text-start">Dosya Kategorisini Seçin</label>
                <select
                    onChange={(e) => {
                        setFileModel(e.target.value)
                    }}
                    value={fileModel}
                    id="hs-select-label"
                    class="py-3 px-4 pr-9  w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400">
                    <option selected>Lütfen Seçiniz</option>
                    <option value="Ameliyat Dosyası">Ameliyat Dosyası</option>
                    <option value="Epikriz Dosyası">Epikriz Dosyası</option>
                    <option value="Patoloji Dosyası">Patoloji Dosyası</option>
                    <option value="CT (Bilgisayarlı Tomografi) Dosyası">CT (Bilgisayarlı Tomografi) Dosyası</option>
                    <option value="MR (Manyetik Rezonans) Dosyası">MR (Manyetik Rezonans) Dosyası</option>
                    <option value="PET (Pozitron Emisyon Tomografi) Dosyası">PET (Pozitron Emisyon Tomografi) Dosyası</option>
                    <option value="USG (Röntgen) Dosyası">USG (Röntgen) Dosyası</option>
                    <option value="Mamografi Dosyası">Mamografi Dosyası</option>
                    <option value="Laboratuvar Dosyası">Laboratuvar Dosyası</option>
                    <option value="Diğer">Diğer</option>
                </select>
            </div>
            <div className='mt-5 ps-5 pe-5 md:ml-64'>
                {props.getApplication.spinner ?
                    <div class="relative">
                        <div style={{ backgroundColor: `#09c35d7c` }} class="bg-blue-50 border border-blue-200 rounded-md p-4">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <i class="fa-light fa-file-import"></i>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm text-blue-800 font-medium">
                                        Dosyalar yükleniyor
                                    </h3>
                                    <div class="text-sm text-blue-700 mt-2">
                                        <span class="font-semibold">Lütfen bekleyin!</span> Dosyaların yüklenmesi devam ediyor.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
                        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <div class="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full" role="status" aria-label="loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    :
                    props.getApplication.done ?

                        props.getApplication.getApplication.attachments.length !== 0 ?

                            <div className="list-group mt-3 mb-3">
                                {
                                    props.getApplication.getApplication.attachments.map((element, index) => {
                                        return (
                                            <>
                                                <div
                                                    key={index}
                                                    class="flex mt-3 flex-col bg-white border shadow-sm rounded-xl p-4 md:p-5 dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7] dark:text-gray-400">
                                                    <div
                                                        className='flex justify-between'>
                                                        <a href={element.viewUrl} target='_blank' className='text-start mb-2'>
                                                            <i class="fa-light fa-arrow-up-from-bracket me-2"></i> {element.fileName}
                                                        </a>
                                                        <div>
                                                            <small className=' me-4'><b>{element.fileId}</b></small>
                                                            <i class="fa-sharp fa-solid fa-circle-check onedose-color me-2"></i>
                                                            <a
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    dispatch(deleteAttachmet(Id, element.id))
                                                                }}
                                                                href="#"><i class="fa-thin fa-trash-can"></i></a>
                                                        </div>
                                                    </div>
                                                    <div class="flex w-full h-1.5 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700">
                                                        <div class="flex flex-col justify-center overflow-hidden bg-blue-500" role="progressbar" style={{ width: `100%`, backgroundColor: `#09C35C` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                                <div id={`hs-vertically-centered-modal${index}`} class="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[100] overflow-x-auto overflow-y-auto">
                                                    <div class="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
                                                        <div class="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                                                            <div class="p-4 overflow-y-auto">
                                                                <div class="ratio ratio-16x9">
                                                                    <iframe src={element.viewUrl} title="YouTube video" allowfullscreen></iframe>
                                                                </div>
                                                            </div>
                                                            <div class="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                                                <button type="button" class="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800" data-hs-overlay="#hs-vertically-centered-modal">
                                                                    Close
                                                                </button>
                                                                <a class="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800" href="#">
                                                                    Save changes
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>

                                        )
                                    })
                                }
                            </div>

                            : null
                        : null
                }
            </div>
            <div className='mt-5 ps-5 pe-5 md:ml-64'>
                <Dropzone
                    onUpload={handleUploadSuccess}
                    onError={handleUploadError}
                    getUploadParams={getUploadParams}
                    onChangeStatus={({ meta, file, remove, xhr }, status) => {
                        if (status === 'done') {
                            remove()
                            setUploadedFiles(prevFiles => [...prevFiles, file.name]);
                            setFileModel("");
                            Swal.fire({
                                position: 'bottom-end',
                                icon: 'success',
                                title: 'Dosyanız başarıyla kaydedildi',
                                showConfirmButton: false,
                                timer: 1000
                            })

                            if (xhr.status === 200) {
                                const res = JSON.parse(xhr.response);
                                const data = JSON.stringify({
                                    "ApplicationId": Id,
                                    "FileType": fileType.toString(),
                                    "FileName": meta.name,
                                    "ViewUrl": res.fileViewerUrl,
                                    "UploadUrl": res.fileDownloadUrl,
                                    "FileId": fileModel
                                });
                                const token = localStorage.getItem("accessToken")
                                var config = {
                                    method: 'post',
                                    maxBodyLength: Infinity,
                                    url: `${API_BASE}/api/v2/second-opinion/attachment`,
                                    headers: {
                                        'One-Id': localStorage.getItem("One-Id"),
                                        'Client-Id': localStorage.getItem("Client-Id"),
                                        'Accept-Language': 'tr-tr',
                                        'Authorization': "Bearer " + token,
                                        'Content-Type': 'application/json'
                                    },
                                    data: data
                                };

                                axios(config)
                                    .then(function (response) {
                                        setIsDisabled(false);
                                        dispatch(getApplication(Id))

                                    })
                                    .catch(function (error) {
                                    });
                            }
                        }
                        setFileName(meta.name);
                        switch (file.type) {
                            case "image/jpeg":
                                setFileType("2")
                                break;
                            case "application/dicom":
                                setFileType("3")
                                break;
                            case "image/png":
                                setFileType("2")
                                break;
                            case "application/pdf":
                                setFileType("1")
                                break;
                            case "application/zip":
                                setFileType("4")
                                break;
                            default:
                                setFileType("4")
                        }
                    }}
                    multiple={true}
                    inputContent={(files, extra) =>
                        extra.reject ? "Sadece resim yükleyebilirsiniz!" : "Dosyaları buraya sürükleyin veya seçmek için tıklayın"
                    }
                    styles={{
                        dropzone: { minHeight: 100 },
                        inputLabel: (files, extra) => (extra.reject ? { color: "red" } : {}),
                    }}
                />
            </div>
            <div className='md:ml-64 ps-5 mt-5 pe-5'>
                <button
                    disabled={isDisabled}
                    onClick={handleSubmit}
                    style={{ backgroundColor: isDisabled ? `#9CA3AF` : `#09C35C` }} // Disabled ise soluk yeşil, değilse canlı yeşil
                    type="button"
                    className={`mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5 ${isDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
                        }`}
                >
                    Devam et
                </button>
            </div>
        </div>
    )
}


const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);